export const cipTypeSchema: any = {
  id: "",
  typeName: "",
  options: [],
  location: {},
  organizationId: "",
  createdBy: "",
};
